package feature.address.viewModel

//import kotlinx.coroutines.IO
import feature.address.handler.AddressHandler
import feature.address.model.Address
import feature.address.repository.AddressRepository
import feature.app.AppViewModel
import feature.auth.model.FriendlyUser
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow

class AddressViewModel : AppViewModel() {
    private val repository: AddressRepository = AddressHandler.shared().repository

    init {
        val user = FriendlyUser()
//        retrieveFor(user._id)
    }

    private var job: Job = Job()
//    private val scope = CoroutineScope(job + Dispatchers.IO)

    val allData: StateFlow<List<Address>>
        get() = repository.allLiveData

    val selectedAddress: StateFlow<Address>
        get() = repository.selectedAddress


    fun loadFor(featureObjectID: String, completion: (ArrayList<Address>) -> Unit) {
//        scope.launch {
//            val allAddress =
//                DatabaseHandler.shared().database.addressDao().getAllItemsFor(featureObjectID)
//            if (allAddress.isNotEmpty()) {
//                completion(allAddress as ArrayList<Address>)
//            } else {
//                retrieveFor(featureObjectID)
//            }
//        }
    }

    //    fun retrieveFor(featureObjectID: String) {
//        val request = JSONObject()
//        val user = FriendlyUser()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        request.put(KeyConstant.featureObjectID, featureObjectID)
//        AddressNetwork.shared().retrieve(request) { responseData ->
//            if (responseData != null && responseData.has(KeyConstant.payload)) {
//                val payload = responseData.getJSONArray(KeyConstant.payload)
//                val allModalObject: ArrayList<Address> = arrayListOf()
//                for (i in 0 until payload.length()) {
//                    val item = payload.getJSONObject(i)
//                    val modelObject = gson.fromJson(item.toString(), Address::class.java)
//                    allModalObject.add(modelObject)
//                    insert(modelObject)
//                }
//                repository.liveData.postValue(allModalObject)
//            }
//        }
//    }
//
//    fun retrieve() {
//        val request = JSONObject()
//        val user = FriendlyUser()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.featureObjectID, business.value?.Id)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        AddressNetwork.shared().retrieve(request) { responseData ->
//            if (responseData != null && responseData.has(KeyConstant.payload)) {
//                val payload = responseData.getJSONArray(KeyConstant.payload)
//                val allModalObject: ArrayList<Address> = arrayListOf()
//                for (i in 0 until payload.length()) {
//                    val item = payload.getJSONObject(i)
//                    val modelObject = gson.fromJson(item.toString(), Address::class.java)
//                    allModalObject.add(modelObject)
//                    insert(modelObject)
//                }
//            }
//        }
//    }
//
    fun createNew(callBack: (Boolean) -> Unit) {
        startLoading()
//        AddressNetwork.shared().create(request) { responseData ->
//            if (responseData != null && responseData.has(KeyConstant.payload)) {
//                val payload = responseData.getJSONObject(KeyConstant.payload)
//                val modelObject = gson.fromJson(payload.toString(), Address::class.java)
//                insert(modelObject)
//                AddressHandler.shared().onCreateResponse?.let { it(modelObject) }
//            }
//        }
    }
//
//    fun updateExistingAddress(request: JSONObject) {
//        SocketService.shared().send(AddressEvent.UPDATE, request)
//    }
//
//    fun deleteExistingAddress(request: JSONObject) {
//        SocketService.shared().send(AddressEvent.DELETE, request)
//    }
//
//    fun insert(newData: Address) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.addressDao().insert(newData)
//        }
//    }
//
//    fun delete(data: Address) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.addressDao().delete(data)
//        }
//    }
}
